
define('text!templates/widgets/multi-account/item.ejs',[],function () { return '<a href="<%= url(\'multi-account#show\', { currencyCode: currencyCode }) %>">\n    <span><%= currencyCode %></span>\n    <i><%= money(balance) %> <small><%= currencyCode %></small></i>\n</a>\n';});

